import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Filter out ResizeObserver errors - these are harmless
    if (
      error?.message?.includes('ResizeObserver') ||
      error?.toString()?.includes('ResizeObserver') ||
      error?.stack?.includes('ResizeObserver')
    ) {
      // Don't set error state for ResizeObserver errors
      return null;
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Filter out ResizeObserver errors - don't log them
    if (
      error?.message?.includes('ResizeObserver') ||
      error?.toString()?.includes('ResizeObserver') ||
      error?.stack?.includes('ResizeObserver')
    ) {
      // Silently ignore ResizeObserver errors
      return;
    }

    // Log other errors normally
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      // Only show error UI for non-ResizeObserver errors
      const errorMessage =
        this.state.error?.message || this.state.error?.toString() || 'Unknown error';
      const errorStack = this.state.error?.stack || '';

      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-bold text-red-600 mb-4">Something went wrong</h2>
            <div className="mb-4">
              <p className="text-gray-700 font-semibold mb-2">Error Message:</p>
              <pre className="bg-gray-100 p-3 rounded text-sm text-red-600 overflow-auto max-h-40 mb-4">
                {errorMessage}
              </pre>
              {errorStack && (
                <>
                  <p className="text-gray-700 font-semibold mb-2">Stack Trace:</p>
                  <pre className="bg-gray-100 p-3 rounded text-xs text-gray-600 overflow-auto max-h-60">
                    {errorStack}
                  </pre>
                </>
              )}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  console.error('Full error details:', this.state.error);
                  window.location.reload();
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Refresh Page
              </button>
              <button
                onClick={() => {
                  console.error('Full error details:', this.state.error);
                  this.setState({ hasError: false, error: null });
                }}
                className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
